import isOk from "./isResponseOk";
import ApiError from "../ApiError";

function catchApiError(msg) {
    return (res) => {
        if (isOk(res)) { return res; }
        throw new ApiError(msg, res);
    };
}

export default catchApiError;



/** WEBPACK FOOTER **
 ** ./app/utils/functions/catchApiError.js
 **/